// Flag slugs for the SudokuFlags widget - one SVG per slug at /public/flags/{slug}.svg
export const FLAG_SLUGS: string[] = [
    'aaland-islands', 'afghanistan', 'albania', 'algeria', 'andorra', 'angola',
    'anguilla', 'antarctica', 'antigua-barbuda', 'argentina', 'armenia', 'aruba',
    'australia', 'austria', 'azerbaijan', 'bahamas', 'bahrain', 'bangladesh',
    'barbados', 'basque', 'belarus', 'belgium', 'belize', 'benin',
    'bermuda', 'bhutan', 'bolivia', 'bosnia-herzegovina', 'botswana', 'brazil',
    'british-virgin-islands', 'brunei', 'bulgaria', 'burkina-faso', 'burundi', 'cambodia',
    'cameroon', 'canada', 'canary-islands', 'cape-verde', 'cayman-islands', 'central-african-republic',
    'chad', 'chile', 'china', 'colombia', 'comoros', 'cook-islands',
    'costa-rica', 'croatia', 'cuba', 'curacao', 'cyprus', 'czechia',
    'democratic-republic-congo', 'denmark', 'djibouti', 'dominica', 'dominican-republic', 'east-timor',
    'ecuador', 'egypt', 'el-salvador', 'england', 'equatorial-guinea', 'eritrea',
    'estonia', 'eswatini', 'ethiopia', 'europe', 'falkland-islands', 'faroe-islands',
    'fiji', 'finland', 'france', 'french-guiana', 'french-polynesia', 'gabon',
    'gambia', 'georgia', 'germany', 'ghana', 'gibraltar', 'greece',
    'greenland', 'grenada', 'guadeloupe', 'guatemala', 'guernsey', 'guinea-bissau',
    'guinea', 'guyana', 'haiti', 'hawaii', 'honduras', 'hong-kong',
    'hungary', 'iceland', 'india', 'indonesia', 'iran', 'iraq',
    'ireland', 'isle-of-man', 'israel', 'italy', 'ivory-coast', 'jamaica',
    'japan', 'jersey', 'jordan', 'kazakhstan', 'kenya', 'kiribati',
    'kosovo', 'kurdistan', 'kuwait', 'kyrgyzstan', 'laos', 'latvia',
    'lebanon', 'lesotho', 'liberia', 'libya', 'liechtenstein', 'lithuania',
    'luxembourg', 'macau', 'madagascar', 'malawi', 'malaysia', 'maldives',
    'mali', 'malta', 'marshall-islands', 'martinique', 'mauritania', 'mauritius',
    'mexico', 'micronesia', 'moldova', 'monaco', 'mongolia', 'montenegro',
    'morocco', 'mozanbique', 'myanmar', 'namibia', 'nauru', 'nepal',
    'netherlands-antilles', 'netherlands', 'new-caledonia', 'new-zealand', 'nicaragua', 'niger',
    'nigeria', 'niue', 'north-korea', 'north-macedonia', 'northen-ireland', 'norway',
    'oman', 'pakistan', 'palau', 'palestine', 'panama', 'papua-new-guinea',
    'paraguay', 'peru', 'philippines', 'poland', 'portugal', 'puerto-rico',
    'qatar', 'republic-congo', 'romania', 'russia', 'rwanda', 'saint-kitts-nevis',
    'saint-lucia', 'saint-vincent-grenadines', 'samoa', 'san-marino', 'sao-tome-principe', 'saudi-arabia',
    'scotland', 'senegal', 'serbia', 'seychelles', 'sierra-leone', 'singapore',
    'sint-maarten', 'slovakia', 'slovenia', 'solomon-islands', 'somalia', 'south-africa',
    'south-georgia-sandwich-islands', 'south-korea', 'south-sudan', 'spain', 'sri-lanka', 'sudan',
    'suriname', 'sweden', 'switzerland', 'syria', 'taiwan', 'tajikistan',
    'tanzania', 'thailand', 'togo', 'tonga', 'trinidad-tobago', 'tunisia',
    'turkey', 'turkmenistan', 'turks-and-caicos-islands', 'tuvalu', 'uganda', 'ukraine',
    'united-arab-emirates', 'united-kingdom', 'united-states-virgin-islands', 'united-states', 'uruguay', 'uzbekistan',
    'vanuatu', 'vatican-city', 'venezuela', 'vietnam', 'wales', 'western-sahara',
    'yemen', 'zambia', 'zimbabwe',
]

const NAME_OVERRIDES: Record<string, string> = {
    'europe': 'European Union',
    'united-states': 'United States',
    'united-kingdom': 'United Kingdom',
    'uae': 'United Arab Emirates',
    'usa': 'United States',
}

export function flagDisplayName(slug: string): string {
    if (NAME_OVERRIDES[slug]) return NAME_OVERRIDES[slug]
    return slug
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
}

// Fisher-Yates shuffle, returns a new array
function shuffle<T>(arr: T[]): T[] {
    const a = arr.slice()
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

// Picks 9 distinct random flags for a new game, in shuffled order (digit 1 = index 0, etc.)
export function pickRandomFlags(): string[] {
    return shuffle(FLAG_SLUGS).slice(0, 9)
}
